export default "__VITE_ASSET__ec50ff44__"